enum AccountTypes {
  PUBLIC = 'public',
  SUBSCRIPTION = 'subscription',
}
export default AccountTypes;
